import { render, staticRenderFns } from "./vanRecordCard.vue?vue&type=template&id=3016f65f&scoped=true&"
import script from "./vanRecordCard.vue?vue&type=script&lang=js&"
export * from "./vanRecordCard.vue?vue&type=script&lang=js&"
import style0 from "./vanRecordCard.vue?vue&type=style&index=0&id=3016f65f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3016f65f",
  null
  
)

export default component.exports